export function delay(time: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
export function getRedirectUrlOutOfOAuthUrl(): string | undefined {
  const urlObj = new URL(window.location.href);
  // try the oauth one first
  let url =
    urlObj.searchParams.get('redirect_uri')?.replace('/callback', '') ||
    undefined;

  // then try our fallback url
  if (!url) {
    url = getRedirectUrlFromParam();
  }
  return url;
}

export function getRedirectUrlFromParam(): string | undefined {
  const urlObj = new URL(window.location.href);
  return urlObj.searchParams.get('redirectUrl') || undefined;
}

enum Domains {
  onearly = 'onearly.com',
  bloodygoodtests = 'bloodygoodtests.com.au',
}

export enum DomainOptions {
  onearly = 'onearly',
  bloodygoodtests = 'bloodygoodtests',
}

interface Theme {
  logo: string;
  logo64: string;
  favicon: string;
  name: string;
}

type ThemeProvider = Record<
  DomainOptions.onearly | DomainOptions.bloodygoodtests,
  Theme
>;

const themes: ThemeProvider = {
  [DomainOptions.onearly]: {
    logo: '/img/oe-new.png',
    logo64: '/img/oe-64.png',
    favicon: '/img/oe-tight-favicon.png',
    name: 'On Early',
  },
  [DomainOptions.bloodygoodtests]: {
    logo: '/img/bgt-new.svg',
    logo64: '/img/bgt-64.png',
    favicon: '/img/tight-favicon.png',
    name: 'Bloody Good Tests',
  },
};

export function getDomainOptionBasedOnDomain() {
  const urlObj = new URL(window.location.href);
  const domain = urlObj.hostname;
  if (domain.includes(Domains.onearly)) {
    return DomainOptions.onearly;
  }
  return DomainOptions.bloodygoodtests;
}

export function getThemeBasedOnDomain(): Theme {
  const domainOption = getDomainOptionBasedOnDomain();
  return themes[domainOption];
}
